import { moduleConstantes } from "@/constantes/module";

export const moduleConstantesPlugin = {
  install(app) {
    app.config.globalProperties.$moduleConstantes = moduleConstantes;
  },
};
